// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"1c779f71","275":"ff764647","710":"fa5b3702","913":"7c7f9958"}[chunkId] + ".chunk.js";
};